import { CountUp } from 'countup.js';
import Alpine from 'alpinejs';

export default function initStatisticsStrip() {
  Alpine.data('statisticsStrip', () => ({
    init() {
      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            const statisticsStripItems = entry.target.querySelectorAll('[data-counter]');
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
              this.instanceCountUp(statisticsStripItems);
              observerInstance.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.7,
        },
      );
      observer.observe(this.$el);
    },
    instanceCountUp(elements: NodeList) {
      elements.forEach((item) => {
        const { prefix, suffix, number } = (item as HTMLElement).dataset;
        const options = {
          prefix,
          suffix,
          duration: 4,
          useEasing: true,
          separator: '.',
          decimal: ',',
        };
        const getValue = parseInt(number ?? '0', 10);
        if (getValue > 0) {
          const countUpInstance = new CountUp(item as HTMLElement, getValue, options);
          countUpInstance.start();
        }
      });
    },
  }));
}
